<app-pagetitle
title="Lista de Contatos"
  [breadcrumbItems]="breadCrumbItems"
></app-pagetitle>

<div class="row" [formGroup]="form">
  @if (error) {
    <div class="col-12">
      <div class="alert alert-danger" role="alert">{{ error }}</div>
    </div>
  } @else {
    <div class="col-3">
      <div class="dataTables_length" id="tickets-table_length">
        <label class="d-inline-flex align-items-center">
          Mostrar
          <select
            formControlName="Paginacao.QuantidadePorPagina"
            name="tickets-table_length"
            aria-controls="tickets-table"
            name="pageSize"
            class="form-control form-control-sm mx-2"
          >
            <option [ngValue]="10" [defaultSelected]="10">10</option>
            <option [ngValue]="25">25</option>
            <option [ngValue]="50">50</option>
            <option [ngValue]="100">100</option>
          </select>
        </label>
      </div>
    </div>
    <div class="table-responsive">
      <table
        class="table align-middle datatable dt-responsive table-check nowrap datatables table-striped table-bordered"
        style="border-collapse: collapse; border-spacing: 0 8px; width: 100%"
      >
        <thead class="bg-light">
          <tr>
            <th class="p-3 text-center actions-column">Ações</th>
            <th class="p-3">
              <div class="d-flex flex-column">
                <span class="fw-bold mb-2">Cliente</span>
                <input
                  type="text"
                  name="cliente"
                  class="form-control form-control-sm"
                  placeholder="Filtrar por cliente"
                  aria-controls="tickets-table"
                  formControlName="cliente"
                />
              </div>
            </th>
            <th class="p-3">
              <div class="d-flex flex-column">
                <span class="fw-bold mb-2">Status</span>
                <select
                  class="form-select form-select-sm"
                  id="statusId"
                  formControlName="statusId"
                >
                  @for (message of statusMessages; track message.id) {
                    <option value="{{ message.id }}">{{ message.nome }}</option>
                  }
                </select>
              </div>
            </th>
            <th class="p-3">
              <div class="d-flex flex-column">
                <span class="fw-bold mb-2">Agendamento</span>
                <input
                  type="date"
                  name="agendamento"
                  class="form-control form-control-sm"
                  placeholder="Filtrar por agendamento"
                  aria-controls="tickets-table"
                  formControlName="agendamento"
                />
              </div>
            </th>
          </tr>
        </thead>

        <tbody>
          @if (isLoading) {
            <tr>
              <td colspan="5" class="text-center position-relative">
                <div
                  class="d-flex justify-content-center align-items-center"
                  style="height: 150px"
                >
                  <span
                    class="spinner-border"
                    style="width: 3rem; height: 3rem"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </div>
              </td>
            </tr>
          } @else {
            @for (row of rows; track $index) {
              <tr>
                <td class="text-center actions-column">
                  <button
                    type="button"
                    class="btn btn-sm text-secondary me-0"
                    [routerLink]="['/clientes', row.clienteId]"
                  >
                    <i class="far fa-eye"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm text-secondary"
                    (click)="open(row)"
                  >
                  <i class="far fa-edit"></i>
                  </button>
                </td>
                <td>{{ row.nomeCliente }}</td>
                <td>
                  <span *ngIf="row.status" [ngClass]="row.status | statusCorFormatter:'cor'" class="badge p-2">{{ row.status | statusCorFormatter:'nome'}}</span>
                </td>
                <td>{{ row.dataAgendamento | date }}</td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
    <!-- Fim da tabela -->
    <div class="row justify-content-md-between align-items-md-center mt-2">
      <!-- Paginação -->
      <div class="col d-flex justify-content-between align-items-center">
        <button (click)="voltar()" type="button" class="btn btn-soft-link waves-effect">Voltar</button>
        <div class="text-md-right float-md-end pagination-rounded">
          <ngb-pagination
            [collectionSize]="pagination.totalDeItens"
            (pageChange)="onPageChange($event)"
            [pageSize]="pagination.quantidadePorPagina"
          ></ngb-pagination>
        </div>
      </div>
      <!-- Fim da Paginação -->
    </div>
  }
</div>
